'use strict';

const universal_color = require('../../../style/universal.color.js');
const fonts$1 = require('../../../style/fonts.js');
const team_color = require('../../../style/team.color.js');

var fonts = {
  family: {
    primary: fonts$1.primaryFont
  }
};
var defaultTheme = {
  fonts: fonts,
  teamThemes: team_color,
  primaryTextColor: universal_color.mlbBlack,
  primaryLinkColor: universal_color.linkBlue,
  primaryLinkHoverColor: universal_color.linkBlueOnDark,
  disabledLinkColor: universal_color.mlbGrey6
};

module.exports = defaultTheme;
